import { render, staticRenderFns } from "./Dp2Settings.vue?vue&type=template&id=00a3f3fa&"
import script from "./Dp2Settings.vue?vue&type=script&lang=ts&"
export * from "./Dp2Settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports